export default "__VITE_PUBLIC_ASSET__9ef5c5c5__"